import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import './EmailLink.sass'
import { useContext } from 'react'
import { AuthContext } from '../../../App'

function EmailLink() {
  return (
    <div className="EmailLink">
      <a href={`mailto:kosim.travku@ya.ru`} className="EmailIcon">
        <Icon name="envelope" weight="solid" />
      </a>
      <div className="Content">
        <a href={`mailto:kosim.travku@ya.ru`} className="Email">
          kosim.travku@ya.ru
        </a>
        <span className="Description">Напишите нам</span>
      </div>
    </div>
  )
}

export default EmailLink
